<template>
  <div class="product">
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>产品</li>
        </ul>
        <h1>我们的产品</h1>
      </div>
    </div>
    <div class="first" id="1">
      <div class="w-default">
        <h1>我们的产品</h1>
        <p class="text-center">安信软件公司拥有自助研发的智慧文博产品线、智慧校园产品线、大数据产品线、智能运维产品线系列产品。</p>
        <div class="item">
          <img src="../assets/img/product/eg-6.jpg" alt />
          <div class="right">
            <div class="detail">
              <h2>文博类应用</h2>
              <h3>在文博行业，安信提供线上展示平台、虚拟展馆、预约服务、藏品管理系统、大数据服务系统、客流分析系统等多个软件产品。</h3>
              <p>
                产品列表：
                <br />客流管理系统、触摸屏导览系统、移动导览系统、团队导览系统、无线定位系统、互动展厅、多媒体信息发布与控制、统一运行管理平台、藏品综合管理系统、综合办公系统、业务集成平台、藏品数字化管理、非物质文化遗产管理系统、文物修复保护管理系统、展览管理系统、教育管理系统、物业管理系统、数字化观众管理系统、大数据平台...
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="items">
      <div class="w-default">
        <div class="item" id="2">
          <div class="right">
            <div class="detail">
              <h2>教育类应用</h2>
              <h3>安信为广大师生提供一个全面的智能感知环境和综合信息服务平台，提供基于角色的个性化定制服务。将基于计算机网络的信息服务融入学校的各个应用与服务领域，实现互联和协作。通过智能感知环境和综合信息服务平台，为学校与外部世界提供一个相互交流和相互感知的接口。</h3>
              <p>
                产品列表：
                <br />四点半课程管理、成绩分系统、智能OA系统、访客管理系统、学生管理系统、资产管理系统、新媒体管理、校园资源管理、综合素质评价、教师评价、校园驾驶舱、家校互通系统、虚拟校园游览、数字广播、数字电视台、大数据平台、智慧校园云平台
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
          <img src="../assets/img/product/eg-3.jpg" alt />
        </div>
        <div class="item" id="3">
          <img src="../assets/img/product/eg-2.jpg" alt />
          <div class="right">
            <div class="detail">
              <h2>物联类应用</h2>
              <h3>安信一体化运维平台[SC-AOP]V2.0是深圳安信软件自主研发的一款面向未来的一体化运维管理平台级产品。该平台致力于为企业一站式解决IT运维管理问题，实现监控一体化、保障智能化、运维自动化。</h3>
              <p>
                平台包含：
                <br />安防设备监控、IT设备监控、应用系统监控、IT资产管理、运维管理系统等子系统。
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
        </div>
        <div class="item" id="3">
          <div class="right">
            <div class="detail">
              <h2>政务类应用</h2>
              <h3>通过云计算、SDN网络、物联网等技术，通过监测、整合、分析、智能响应，实现各职能部门的各种资源的高度整合，提高政府的业务办理和管理效率；加强职能监管，使政府更加廉洁、勤政、务实，提高政府的透明度；形成高效、敏捷、便民的新型政府，保证城市可持续发展，为企业和公众建立一个良好的城市生活环境。</h3>
              <p>
                平台包含：
                <br />法律文书监督平台、公共信息平台、慈善信息平台、综合办公系统
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
          <img src="../assets/img/product/eg-4.jpg" alt />
        </div>
        <div class="item" id="4">
          <img src="../assets/img/product/eg-5.jpg" alt />
          <div class="right">
            <div class="detail">
              <h2>大数据平台</h2>
              <h3>零编码、一站式解决企业数据集成问题，让企业的数据融合为一个整体，发挥应用的价值。</h3>
              <p>
                平台包含：
                <br />数据采集、 数据交换、
                <br />数据处理、 数据质量、
                <br />数据服务、 数据服务等功能组件。
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
        </div>
        <div class="item" id="5">
          <div class="right">
            <div class="detail">
              <h2>应用支撑平台</h2>
              <h3>致力于帮助企业搭建信息化基础设施，提升企业信息化支撑能力，实现业务敏捷变更，同时提升企业掌控能力。</h3>
              <p>
                平台包含：
                <br />视频分析、音频分析、自然语言分析、 大数据分析、工作流、报表、 数据可视化、智能表单、开发平台、 测试平台、数据可视化、智能表单、 门户服务、消息服务、网关服务、 统一管理、地理信息服务等功能组件。
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
          <img src="../assets/img/product/eg-1.jpg" alt />
        </div>
        <div class="item" id="6">
          <img src="../assets/img/product/eg-5.jpg" alt />
          <div class="right">
            <div class="detail">
              <h2>智慧安防综合业务管理平台</h2>
              <h3>智慧安防综合业务管理平台是以视频为核心，网络为纽带，运用互联网思维和技术、云计算、大数据分析、智能技术等集成的综合业务管理平台。</h3>
              <p>
                平台包含：
                <br />视频监控、消防报警、
                <br />能源安全、视频会议、
                <br />数人脸识别、智能分析、
                <br />门禁、停车场、传感器及其他第三方系统
              </p>
              <!-- <a>了解更多>></a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {
    let index = this.$route.query.id
    if(index){
      document.getElementById(index).scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.product {
  .other-banner {
    background: url("@/../../assets/img/banner/banner4.jpg");
    .crumb {
      li:last-child {
        color: #ffffff !important;
      }
    }
  }
  .first {
    padding-top: 98px;
    background: url("@../../../assets/img/product/bg.png");
    padding-bottom: 60px;
    > .w-default {
      > h1 {
        font-size: 42px;
        text-align: center;
        margin-bottom: 42px;
      }
      > p {
        font-size: 16px;
        margin-bottom: 60px;
      }
    }
  }
  .items {
    .item {
      margin-bottom: 20px;
      padding-top: 100px;
    }
  }
  .item {
    display: flex;
    img {
      width: 760px;
      height: 450px;
      object-fit: cover;
    }
    .right {
      flex: 1;
      background: #ffffff;
      display: flex;
      align-items: center;
      padding: 0 36px;
      .detail {
        h2 {
          font-size: 28px;
          margin-bottom: 16px;
        }
        h3 {
          line-height: 1.5;
          font-size: 16px;
          margin-bottom: 14px;
        }
        p {
          line-height: 1.5;
          font-size: 14px;
          margin-bottom: 20px;
        }
        a {
          color: map-get($colors, "primary");
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
